export async function initSliders() {
    const swiperClass = '.content-swiper';

    const swipers = $(swiperClass);

    if (!swipers.length) {
        return;
    }

    import('$c3base/swiper-imports.js').then(({Swiper}) => {
        swipers.each(async function () {
            const config = $(this).data();

            if (config.responsiveInit > 0) {
                _checkWidth($(this), config);
                $(window).resize(() => {
                    _checkWidth($(this), config);
                });
            } else {
                _init($(this), config);
            }
        });
 
        window.dispatchEvent(new CustomEvent('c3.swiper.global.initialized'));

        /**
         * @param {jQuery | JQuery} el
         * @param {SliderConfig} config
         * @private
         */
        function _checkWidth(el, config) {
            if (window.innerWidth < config.responsiveInit) {
                if (!el[0].swiper) {
                    _init(el, config);
                    el.removeClass('disabled');
                }
            } else {
                el.addClass('disabled');
                el[0].swiper?.destroy();
            }
        }

        /**
         * @param {jQuery | JQuery} el
         * @param {SliderConfig} config
         * @private
         */
        function _init(el, config) {
            const swiperConfig = {
                slidesPerView: config.slidesPerView,
                spaceBetween: config.spaceBetween ?? 0,
                grabCursor: config.grabCursor,
                centeredSlides: config.centeredSlides,
                effect: config.effect,
                speed: config.speed,
                direction: config.direction,
                loop: config.loop,
                reverseDirection: config.reverseDirection,
                freeMode: config.freeMode,
                breakpoints: config.breakpoints,
                a11y: {
                    firstSlideMessage: config.firstSlideMessage,
                    lastSlideMessage: config.lastSlideMessage,
                    nextSlideMessage: config.nextSlideMessage,
                    paginationBulletMessage: config.paginationBulletMessage,
                    prevSlideMessage: config.prevSlideMessage
                }
            };

            const pagination = el.find('.swiper-pagination');
            if (pagination.length) {
                swiperConfig.pagination = {
                    el: pagination[0],
                    clickable: true
                };
            }

            const nextButton = el.siblings('.swiper-button-next');
            const prevButton = el.siblings('.swiper-button-prev');
            if (nextButton.length && prevButton.length) {
                swiperConfig.navigation = {
                    nextEl: nextButton[0],
                    prevEl: prevButton[0],
                };
            }

            if (config.delay) {
                swiperConfig.autoplay = {
                    delay: config.delay,
                };
            }

            if (config.showOverflow) {
                el.wrap('<div class="swiper-overflow-wrap">');
                el.css('max-width', config.width);
            }

            if (config.direction === 'vertical') {
                let maxHeight = 0;
                el.find('.swiper-slide').each(function () {
                    if (maxHeight < el.height()) {
                        maxHeight = el.height();
                    }
                });
                el.find('.swiper-wrapper').height(maxHeight);
            }

            if (config.thumbs) {
                const thumbSwiperConfig = {
                    slidesPerView: config.thumbsSlidesPerView,
                    freeMode: config.thumbsFreeMode,
                };
                const thumbSwiper = new Swiper(el.siblings('.thumb-slider'), thumbSwiperConfig);
                swiperConfig.thumbs = {
                    swiper: thumbSwiper[0]
                };
            }

            switch (config.effect) {
                case 'flip':
                    swiperConfig.slidesPerView = 1;
            }

            const swiper = new Swiper(el[0], swiperConfig);

            const initEvent = new CustomEvent('c3.swiper.initialized', {
                detail: {
                    container: el[0],
                    swiper
                }
            });
            el[0].dispatchEvent(initEvent);
        }
    });
}
